import * as z from 'zod/mini';
import { GlobalOptionsSchema } from './global';

export const CalendarOptions = z.object({
  ...GlobalOptionsSchema,
  // eslint-disable-next-line no-underscore-dangle
  initialPax: z._default(z.optional(z.number()), 2),
  // eslint-disable-next-line no-underscore-dangle
  minPax: z._default(z.optional(z.number()), 1),
  // eslint-disable-next-line no-underscore-dangle
  maxPax: z._default(z.optional(z.number()), 6),
  packageId: z.union([z.string(), z.number()]),
  bookingUrl: z.string(),
});
